import classNames from 'classnames';
import { documentContainer } from './Document.css';
import type { DocumentProps } from './Document.types';

const Document = ({ children, className }: DocumentProps) => {
  return <div className={classNames(documentContainer, className)}>{children}</div>;
};

export { Document };
